import React from "react"
import Select from "react-select"
import { layoutModeTypes } from "constants/layout"

const CustomMultiSelect = ({
  name,
  value,
  onChange,
  options,
  placeholder,
  isDisabled,
  layoutMode
}) => {

  const customStyles =
   (layoutMode && layoutMode !== layoutModeTypes.LIGHT)
      ? {
          control: (base, state) => ({
            ...base,
            backgroundColor: "#262B3C",
            borderColor: "#353d55",
            boxShadow: "none",
            ":hover": {
              borderColor: "#353d55",
            },
          }),
          valueContainer: base => ({
            ...base,
            backgroundColor: "transparent",
            color: "#00778b",
            padding: "0 8px",
          }),
          input: (baseStyles, state) => ({
            ...baseStyles,
            color: "#fff",
            margin: 0,
            padding: 0,
          }),
          singleValue: base => ({
            ...base,
            color: "#fff",
          }),
          placeholder: base => ({
            ...base,
            color: "#fff",
          }),
          menu: base => ({
            ...base,
            backgroundColor: "#262B3C",
          }),
          option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isSelected
              ? "#00778b"
              : isFocused
              ? "#025360"
              : "#262B3C",
            color: isSelected || isFocused ? "#fff" : "#ccc",
            ":active": {
              backgroundColor: "#00778b",
            },
          }),
          multiValue: styles => ({
            ...styles,
            backgroundColor: "#00778b",
          }),
          multiValueLabel: styles => ({
            ...styles,
            color: "#fff",
            background: "transparent",
          }),
          multiValueRemove: styles => ({
            ...styles,
            backgroundColor: "#00778b",
            color: "#fff",
            ":hover": {
              backgroundColor: "#025360",
              color: "#fff",
            },
          }),
          clearIndicator: base => ({
            ...base,
            backgroundColor: "#262B3C",
            color: "#fff",
            padding: 6,
            ":hover": {
              color: "#b4b4b4",
            },
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            backgroundColor: "#262B3C",
            color: "#fff",
            padding: 6,
            transition: "all 0.3s ease",
            ":hover": {
              color: "#b4b4b4",
            },
          }),
          indicatorsContainer: base => ({
            ...base,
            backgroundColor: "transparent",
          }),
          // container: base => $({ ...base, width: "100%" }),
          // group: base => $({ ...base, width: "100%" }),
          // groupHeading: base => $({ ...base, width: "100%" }),
          // indicatorSeparator: base => $({ ...base, width: "100%" }),
          // loadingIndicator: base => $({ ...base, width: "100%" }),
          // loadingMessage: base => $({ ...base, width: "100%" }),
          // // menuList: base => $({ ...base, width: "100%" }),
          // // menuPortal: base => $({ ...base, width: "100%" }),
          // noOptionsMessage: base => $({ ...base, width: "100%" }),
        }
      : {}

  return (
    <Select
      name={name}
      value={value}
      isMulti={true}
      onChange={onChange}
      options={options}
      className="react-select-container"
      placeholder={placeholder}
      closeMenuOnSelect={false}
      isDisabled={isDisabled}
      styles={customStyles}
      classNamePrefix="react-select"
    />
  );
};

export default CustomMultiSelect;
